import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./index.css";

const CookieNotification = () => {
  const [cookie, setCookie] = useState(localStorage.getItem("cookieSeen"));
  const location = useLocation();

  useEffect(() => {
    if (cookie) {
      setCookie(localStorage.getItem("cookieSeen"));
    }
  }, [cookie]);

  const closeCookieBanner = () => {
    localStorage.setItem("cookieSeen", "shown");
    setCookie("shown");
  };

  return (
    <div
      className={`cookie-banner ${
        cookie || location.pathname.includes("/app") ? "d-none" : "d-none"
      }`}
    >
      <p className="pb-0">
        By using this website, you agree to our use of{" "}
        <Link
          to="/cookie_policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-violet"
        >
          cookie policy
        </Link>
        . We use cookies to provide you with a great experience and to help our
        website run effectively.
      </p>
      <button
        className="btn btn-sm p-1 px-2 btn-violet"
        onClick={(e) => closeCookieBanner()}
      >
        Got it
      </button>
    </div>
  );
};

export default CookieNotification;
